import Icon from '../components/Icon.vue'

Icon.register({
  'sort-numeric-down': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M308.8 113.8L289.4 93C284.8 88.2 285.1 80.6 289.9 76L333.4 35.3A12-12 0 0 0 341.6 32.1H373.2C379.8 32.1 385.2 37.4 385.2 44.1V171.1H410.8C417.4 171.1 422.8 176.5 422.8 183.1V212.1C422.8 218.7 417.4 224.1 410.8 224.1H301.6C295 224.1 289.6 218.7 289.6 212.1V183.1C289.6 176.5 295 171.1 301.6 171.1H327.1V113.2C319.8 119.8 312.9 118.1 308.8 113.8zM278.2 352.4C278.2 319.7 302.1 285 346.3 285 384.6 285 425.8 313.9 425.8 377.2 425.8 428.5 393.5 483 333.8 483 315.9 483 303.2 479.4 295.2 476.2 289.4 473.9 286.4 467.5 288.3 461.5L297.5 432C299.6 425.5 306.6 422.1 313 424.3 326 428.9 340.9 429.6 351.1 420.2 312.4 425.3 278.2 394.8 278.2 352.4zM370.5 371.7C370.5 349.4 355.2 335.2 344.7 335.2 336 335.2 331.5 343.2 331.5 351 331.5 356.7 333.3 375.2 356.7 375.2 366.7 375.2 370.1 373 370.4 372.5 370.4 372.4 370.5 372.2 370.5 371.7zM176 368H128V48C128 39.2 120.8 32 112 32H80C71.2 32 64 39.2 64 48V368H16C1.8 368-5.4 385.2 4.7 395.3L84.7 475.3C90.9 481.6 101.1 481.6 107.3 475.3L187.3 395.3C197.3 385.3 190.2 368 176 368z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sort-numeric-down.js
// module id = vqYz
// module chunks = 144